/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AddFeatureRequest,
  AddInteractionActionRequest,
  AddInteractionRequest,
  AddInteractionResponse,
  AddWhitelistRequest,
  AuthControllerGetProfile200Response,
  AuthControllerRefreshAccessToken200Response,
  ChatRequest,
  ChunkDeleteRequest,
  ChunkEditRequest,
  ChunkEditResponse,
  ChunkQueueRequest,
  ChunkQueueResponse,
  ChunkRequest,
  ChunkStatusResponse,
  ClassAddRequest,
  ClassAddResponse,
  ClassDeletePendingEnrollmentRequest,
  ClassEnrollDeleteRequest,
  ClassEnrollRequest,
  ClassEnrollResponse,
  ClassInfoResponse,
  ClassListResponse,
  ClassPendingEnrollmentRequest,
  ClassPendingEnrollmentResponse,
  ClassRosterRequest,
  ClassRosterResponse,
  ClassUpdateMetadataRequest,
  ClassUpdateMetadataResponse,
  CreateEmbeddingDto,
  DateFilterRequest,
  DescribeResponse,
  DocumentChatResponse,
  DocumentIdsChatResponse,
  DocumentListResponse,
  DocumentUploadResponse,
  EditFeatureRequest,
  EmbeddingResponseDto,
  FeatureResponse,
  GetDocumentResponse,
  HealthControllerCheck200Response,
  HealthControllerCheck503Response,
  ListWhitelistResponse,
  MaterialAddRequest,
  MaterialAddResponse,
  MaterialDeleteRequest,
  MaterialEditRequest,
  MaterialEditResponse,
  MaterialListRequest,
  MaterialListResponse,
  PresentResponse,
  PresentSessionRequest,
  PresentUserRequest,
  QueryRequest,
  QueryResponse,
  StudentChatRequest,
  StudentChatResponse,
  StudentEnrollmentsResponse,
  StudentSummaryRequest,
  StudentSummaryResponse,
  UpdateWhitelistRequest,
} from '../models/index';
import {
    AddFeatureRequestFromJSON,
    AddFeatureRequestToJSON,
    AddInteractionActionRequestFromJSON,
    AddInteractionActionRequestToJSON,
    AddInteractionRequestFromJSON,
    AddInteractionRequestToJSON,
    AddInteractionResponseFromJSON,
    AddInteractionResponseToJSON,
    AddWhitelistRequestFromJSON,
    AddWhitelistRequestToJSON,
    AuthControllerGetProfile200ResponseFromJSON,
    AuthControllerGetProfile200ResponseToJSON,
    AuthControllerRefreshAccessToken200ResponseFromJSON,
    AuthControllerRefreshAccessToken200ResponseToJSON,
    ChatRequestFromJSON,
    ChatRequestToJSON,
    ChunkDeleteRequestFromJSON,
    ChunkDeleteRequestToJSON,
    ChunkEditRequestFromJSON,
    ChunkEditRequestToJSON,
    ChunkEditResponseFromJSON,
    ChunkEditResponseToJSON,
    ChunkQueueRequestFromJSON,
    ChunkQueueRequestToJSON,
    ChunkQueueResponseFromJSON,
    ChunkQueueResponseToJSON,
    ChunkRequestFromJSON,
    ChunkRequestToJSON,
    ChunkStatusResponseFromJSON,
    ChunkStatusResponseToJSON,
    ClassAddRequestFromJSON,
    ClassAddRequestToJSON,
    ClassAddResponseFromJSON,
    ClassAddResponseToJSON,
    ClassDeletePendingEnrollmentRequestFromJSON,
    ClassDeletePendingEnrollmentRequestToJSON,
    ClassEnrollDeleteRequestFromJSON,
    ClassEnrollDeleteRequestToJSON,
    ClassEnrollRequestFromJSON,
    ClassEnrollRequestToJSON,
    ClassEnrollResponseFromJSON,
    ClassEnrollResponseToJSON,
    ClassInfoResponseFromJSON,
    ClassInfoResponseToJSON,
    ClassListResponseFromJSON,
    ClassListResponseToJSON,
    ClassPendingEnrollmentRequestFromJSON,
    ClassPendingEnrollmentRequestToJSON,
    ClassPendingEnrollmentResponseFromJSON,
    ClassPendingEnrollmentResponseToJSON,
    ClassRosterRequestFromJSON,
    ClassRosterRequestToJSON,
    ClassRosterResponseFromJSON,
    ClassRosterResponseToJSON,
    ClassUpdateMetadataRequestFromJSON,
    ClassUpdateMetadataRequestToJSON,
    ClassUpdateMetadataResponseFromJSON,
    ClassUpdateMetadataResponseToJSON,
    CreateEmbeddingDtoFromJSON,
    CreateEmbeddingDtoToJSON,
    DateFilterRequestFromJSON,
    DateFilterRequestToJSON,
    DescribeResponseFromJSON,
    DescribeResponseToJSON,
    DocumentChatResponseFromJSON,
    DocumentChatResponseToJSON,
    DocumentIdsChatResponseFromJSON,
    DocumentIdsChatResponseToJSON,
    DocumentListResponseFromJSON,
    DocumentListResponseToJSON,
    DocumentUploadResponseFromJSON,
    DocumentUploadResponseToJSON,
    EditFeatureRequestFromJSON,
    EditFeatureRequestToJSON,
    EmbeddingResponseDtoFromJSON,
    EmbeddingResponseDtoToJSON,
    FeatureResponseFromJSON,
    FeatureResponseToJSON,
    GetDocumentResponseFromJSON,
    GetDocumentResponseToJSON,
    HealthControllerCheck200ResponseFromJSON,
    HealthControllerCheck200ResponseToJSON,
    HealthControllerCheck503ResponseFromJSON,
    HealthControllerCheck503ResponseToJSON,
    ListWhitelistResponseFromJSON,
    ListWhitelistResponseToJSON,
    MaterialAddRequestFromJSON,
    MaterialAddRequestToJSON,
    MaterialAddResponseFromJSON,
    MaterialAddResponseToJSON,
    MaterialDeleteRequestFromJSON,
    MaterialDeleteRequestToJSON,
    MaterialEditRequestFromJSON,
    MaterialEditRequestToJSON,
    MaterialEditResponseFromJSON,
    MaterialEditResponseToJSON,
    MaterialListRequestFromJSON,
    MaterialListRequestToJSON,
    MaterialListResponseFromJSON,
    MaterialListResponseToJSON,
    PresentResponseFromJSON,
    PresentResponseToJSON,
    PresentSessionRequestFromJSON,
    PresentSessionRequestToJSON,
    PresentUserRequestFromJSON,
    PresentUserRequestToJSON,
    QueryRequestFromJSON,
    QueryRequestToJSON,
    QueryResponseFromJSON,
    QueryResponseToJSON,
    StudentChatRequestFromJSON,
    StudentChatRequestToJSON,
    StudentChatResponseFromJSON,
    StudentChatResponseToJSON,
    StudentEnrollmentsResponseFromJSON,
    StudentEnrollmentsResponseToJSON,
    StudentSummaryRequestFromJSON,
    StudentSummaryRequestToJSON,
    StudentSummaryResponseFromJSON,
    StudentSummaryResponseToJSON,
    UpdateWhitelistRequestFromJSON,
    UpdateWhitelistRequestToJSON,
} from '../models/index';

export interface AnalyticsControllerPresentDateFilteredInteractionsRequest {
    dateFilterRequest: DateFilterRequest;
}

export interface AnalyticsControllerPresentSessionInteractionsRequest {
    presentSessionRequest: PresentSessionRequest;
}

export interface AnalyticsControllerPresentUserInteractionsRequest {
    presentUserRequest: PresentUserRequest;
}

export interface ChatControllerCreateChatRequest {
    chatRequest: ChatRequest;
}

export interface ChatControllerCreateChatStreamRequest {
    chatRequest: ChatRequest;
}

export interface ClassControllerAddRequest {
    classAddRequest: ClassAddRequest;
}

export interface ClassControllerDeleteRequest {
    classEnrollDeleteRequest: ClassEnrollDeleteRequest;
}

export interface ClassControllerDeletePendingUsersRequest {
    classDeletePendingEnrollmentRequest: ClassDeletePendingEnrollmentRequest;
}

export interface ClassControllerEnrollRequest {
    classEnrollRequest: ClassEnrollRequest;
}

export interface ClassControllerGetByIdRequest {
    classID: string;
}

export interface ClassControllerGetDocumentListRequest {
    classID: string;
}

export interface ClassControllerGetDocumentListIdsRequest {
    classID: string;
}

export interface ClassControllerGetPendingEnrollmentRequest {
    classPendingEnrollmentRequest: ClassPendingEnrollmentRequest;
}

export interface ClassControllerRosterRequest {
    classRosterRequest: ClassRosterRequest;
}

export interface ClassControllerUpdateMetadataRequest {
    classUpdateMetadataRequest: ClassUpdateMetadataRequest;
}

export interface DocumentControllerAddChunkFieldRequest {
    chunkEditRequest: ChunkEditRequest;
}

export interface DocumentControllerChunkRequest {
    chunkRequest: ChunkRequest;
}

export interface DocumentControllerChunkStatusRequest {
    chunkQueueRequest: ChunkQueueRequest;
}

export interface DocumentControllerDeleteChunkViaPostRequest {
    chunkDeleteRequest: ChunkDeleteRequest;
}

export interface DocumentControllerDescribeRequest {
    chunkRequest: ChunkRequest;
}

export interface DocumentControllerEditChunkFieldRequest {
    chunkEditRequest: ChunkEditRequest;
}

export interface DocumentControllerEmbedRequest {
    chunkRequest: ChunkRequest;
}

export interface DocumentControllerGetListByMaterialIdRequest {
    materialID: string;
}

export interface DocumentControllerQueryRequest {
    queryRequest: QueryRequest;
}

export interface DocumentControllerRemoveEmbedRequest {
    chunkRequest: ChunkRequest;
}

export interface DocumentControllerRetrieveDocumentRequest {
    chunkRequest: ChunkRequest;
}

export interface DocumentControllerUploadRequest {
    file: Blob;
    classMaterialId: string;
}

export interface EmbeddingControllerCreateEmbeddingRequest {
    createEmbeddingDto: CreateEmbeddingDto;
}

export interface FeatureFlagsControllerAddClassFeatureRequest {
    addFeatureRequest: AddFeatureRequest;
}

export interface FeatureFlagsControllerAddUserFeatureRequest {
    addFeatureRequest: AddFeatureRequest;
}

export interface FeatureFlagsControllerEditClassFeatureRequest {
    editFeatureRequest: EditFeatureRequest;
}

export interface FeatureFlagsControllerEditUserFeatureRequest {
    editFeatureRequest: EditFeatureRequest;
}

export interface FeatureFlagsControllerListClassFeaturesRequest {
    classId: string;
}

export interface FeatureFlagsControllerListUserFeaturesRequest {
    userId: string;
}

export interface InteractionControllerAddInteractionRequest {
    addInteractionRequest: AddInteractionRequest;
}

export interface InteractionControllerAddInteractionActionRequest {
    addInteractionActionRequest: AddInteractionActionRequest;
}

export interface MaterialControllerAddRequest {
    materialAddRequest: MaterialAddRequest;
}

export interface MaterialControllerDeleteRequest {
    materialDeleteRequest: MaterialDeleteRequest;
}

export interface MaterialControllerEditRequest {
    materialEditRequest: MaterialEditRequest;
}

export interface MaterialControllerGetListByMaterialIdRequest {
    materialID: string;
}

export interface MaterialControllerListRequest {
    materialListRequest: MaterialListRequest;
}

export interface StudentControllerChatRequest {
    studentChatRequest: StudentChatRequest;
}

export interface StudentControllerSummaryRequest {
    studentSummaryRequest: StudentSummaryRequest;
}

export interface WhitelistControllerAddUserToWhitelistRequest {
    addWhitelistRequest: AddWhitelistRequest;
}

export interface WhitelistControllerUpdateUserWhitelistRequest {
    updateWhitelistRequest: UpdateWhitelistRequest;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     */
    async analyticsControllerPresentAllInteractionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/analytics/all`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async analyticsControllerPresentAllInteractions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.analyticsControllerPresentAllInteractionsRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async analyticsControllerPresentDateFilteredInteractionsRaw(requestParameters: AnalyticsControllerPresentDateFilteredInteractionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters.dateFilterRequest === null || requestParameters.dateFilterRequest === undefined) {
            throw new runtime.RequiredError('dateFilterRequest','Required parameter requestParameters.dateFilterRequest was null or undefined when calling analyticsControllerPresentDateFilteredInteractions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/analytics/DateFiltered`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DateFilterRequestToJSON(requestParameters.dateFilterRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     */
    async analyticsControllerPresentDateFilteredInteractions(requestParameters: AnalyticsControllerPresentDateFilteredInteractionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.analyticsControllerPresentDateFilteredInteractionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async analyticsControllerPresentSessionInteractionsRaw(requestParameters: AnalyticsControllerPresentSessionInteractionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PresentResponse>> {
        if (requestParameters.presentSessionRequest === null || requestParameters.presentSessionRequest === undefined) {
            throw new runtime.RequiredError('presentSessionRequest','Required parameter requestParameters.presentSessionRequest was null or undefined when calling analyticsControllerPresentSessionInteractions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/analytics/session`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PresentSessionRequestToJSON(requestParameters.presentSessionRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PresentResponseFromJSON(jsonValue));
    }

    /**
     */
    async analyticsControllerPresentSessionInteractions(requestParameters: AnalyticsControllerPresentSessionInteractionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PresentResponse> {
        const response = await this.analyticsControllerPresentSessionInteractionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async analyticsControllerPresentUserInteractionsRaw(requestParameters: AnalyticsControllerPresentUserInteractionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PresentResponse>> {
        if (requestParameters.presentUserRequest === null || requestParameters.presentUserRequest === undefined) {
            throw new runtime.RequiredError('presentUserRequest','Required parameter requestParameters.presentUserRequest was null or undefined when calling analyticsControllerPresentUserInteractions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/analytics/user`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: PresentUserRequestToJSON(requestParameters.presentUserRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PresentResponseFromJSON(jsonValue));
    }

    /**
     */
    async analyticsControllerPresentUserInteractions(requestParameters: AnalyticsControllerPresentUserInteractionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PresentResponse> {
        const response = await this.analyticsControllerPresentUserInteractionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async appControllerGetHelloRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async appControllerGetHello(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.appControllerGetHelloRaw(initOverrides);
    }

    /**
     */
    async authControllerGetProfileRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthControllerGetProfile200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/auth/profile`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthControllerGetProfile200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async authControllerGetProfile(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthControllerGetProfile200Response> {
        const response = await this.authControllerGetProfileRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async authControllerGoogleAuthRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/auth`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async authControllerGoogleAuth(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authControllerGoogleAuthRaw(initOverrides);
    }

    /**
     */
    async authControllerGoogleAuthRedirectRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/auth/google`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async authControllerGoogleAuthRedirect(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authControllerGoogleAuthRedirectRaw(initOverrides);
    }

    /**
     */
    async authControllerRefreshAccessTokenRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuthControllerRefreshAccessToken200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/auth/refresh-token`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuthControllerRefreshAccessToken200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async authControllerRefreshAccessToken(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuthControllerRefreshAccessToken200Response> {
        const response = await this.authControllerRefreshAccessTokenRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async chatControllerCreateChatRaw(requestParameters: ChatControllerCreateChatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.chatRequest === null || requestParameters.chatRequest === undefined) {
            throw new runtime.RequiredError('chatRequest','Required parameter requestParameters.chatRequest was null or undefined when calling chatControllerCreateChat.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chat`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChatRequestToJSON(requestParameters.chatRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async chatControllerCreateChat(requestParameters: ChatControllerCreateChatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.chatControllerCreateChatRaw(requestParameters, initOverrides);
    }

    /**
     */
    async chatControllerCreateChatStreamRaw(requestParameters: ChatControllerCreateChatStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.chatRequest === null || requestParameters.chatRequest === undefined) {
            throw new runtime.RequiredError('chatRequest','Required parameter requestParameters.chatRequest was null or undefined when calling chatControllerCreateChatStream.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/chat/stream`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChatRequestToJSON(requestParameters.chatRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async chatControllerCreateChatStream(requestParameters: ChatControllerCreateChatStreamRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.chatControllerCreateChatStreamRaw(requestParameters, initOverrides);
    }

    /**
     */
    async classControllerAddRaw(requestParameters: ClassControllerAddRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClassAddResponse>> {
        if (requestParameters.classAddRequest === null || requestParameters.classAddRequest === undefined) {
            throw new runtime.RequiredError('classAddRequest','Required parameter requestParameters.classAddRequest was null or undefined when calling classControllerAdd.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/class/add`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClassAddRequestToJSON(requestParameters.classAddRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClassAddResponseFromJSON(jsonValue));
    }

    /**
     */
    async classControllerAdd(requestParameters: ClassControllerAddRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClassAddResponse> {
        const response = await this.classControllerAddRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async classControllerDeleteRaw(requestParameters: ClassControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.classEnrollDeleteRequest === null || requestParameters.classEnrollDeleteRequest === undefined) {
            throw new runtime.RequiredError('classEnrollDeleteRequest','Required parameter requestParameters.classEnrollDeleteRequest was null or undefined when calling classControllerDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/class/enroll/delete`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClassEnrollDeleteRequestToJSON(requestParameters.classEnrollDeleteRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async classControllerDelete(requestParameters: ClassControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.classControllerDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async classControllerDeletePendingUsersRaw(requestParameters: ClassControllerDeletePendingUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.classDeletePendingEnrollmentRequest === null || requestParameters.classDeletePendingEnrollmentRequest === undefined) {
            throw new runtime.RequiredError('classDeletePendingEnrollmentRequest','Required parameter requestParameters.classDeletePendingEnrollmentRequest was null or undefined when calling classControllerDeletePendingUsers.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/class/pending-enrollment/delete`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClassDeletePendingEnrollmentRequestToJSON(requestParameters.classDeletePendingEnrollmentRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async classControllerDeletePendingUsers(requestParameters: ClassControllerDeletePendingUsersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.classControllerDeletePendingUsersRaw(requestParameters, initOverrides);
    }

    /**
     */
    async classControllerEnrollRaw(requestParameters: ClassControllerEnrollRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClassEnrollResponse>> {
        if (requestParameters.classEnrollRequest === null || requestParameters.classEnrollRequest === undefined) {
            throw new runtime.RequiredError('classEnrollRequest','Required parameter requestParameters.classEnrollRequest was null or undefined when calling classControllerEnroll.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/class/enroll`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClassEnrollRequestToJSON(requestParameters.classEnrollRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClassEnrollResponseFromJSON(jsonValue));
    }

    /**
     */
    async classControllerEnroll(requestParameters: ClassControllerEnrollRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClassEnrollResponse> {
        const response = await this.classControllerEnrollRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async classControllerGetByIdRaw(requestParameters: ClassControllerGetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClassInfoResponse>> {
        if (requestParameters.classID === null || requestParameters.classID === undefined) {
            throw new runtime.RequiredError('classID','Required parameter requestParameters.classID was null or undefined when calling classControllerGetById.');
        }

        const queryParameters: any = {};

        if (requestParameters.classID !== undefined) {
            queryParameters['classID'] = requestParameters.classID;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/class/id`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClassInfoResponseFromJSON(jsonValue));
    }

    /**
     */
    async classControllerGetById(requestParameters: ClassControllerGetByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClassInfoResponse> {
        const response = await this.classControllerGetByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async classControllerGetDocumentListRaw(requestParameters: ClassControllerGetDocumentListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentChatResponse>> {
        if (requestParameters.classID === null || requestParameters.classID === undefined) {
            throw new runtime.RequiredError('classID','Required parameter requestParameters.classID was null or undefined when calling classControllerGetDocumentList.');
        }

        const queryParameters: any = {};

        if (requestParameters.classID !== undefined) {
            queryParameters['classID'] = requestParameters.classID;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/class/document/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentChatResponseFromJSON(jsonValue));
    }

    /**
     */
    async classControllerGetDocumentList(requestParameters: ClassControllerGetDocumentListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentChatResponse> {
        const response = await this.classControllerGetDocumentListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async classControllerGetDocumentListIdsRaw(requestParameters: ClassControllerGetDocumentListIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentIdsChatResponse>> {
        if (requestParameters.classID === null || requestParameters.classID === undefined) {
            throw new runtime.RequiredError('classID','Required parameter requestParameters.classID was null or undefined when calling classControllerGetDocumentListIds.');
        }

        const queryParameters: any = {};

        if (requestParameters.classID !== undefined) {
            queryParameters['classID'] = requestParameters.classID;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/class/document/list/ids`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentIdsChatResponseFromJSON(jsonValue));
    }

    /**
     */
    async classControllerGetDocumentListIds(requestParameters: ClassControllerGetDocumentListIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentIdsChatResponse> {
        const response = await this.classControllerGetDocumentListIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async classControllerGetPendingEnrollmentRaw(requestParameters: ClassControllerGetPendingEnrollmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClassPendingEnrollmentResponse>> {
        if (requestParameters.classPendingEnrollmentRequest === null || requestParameters.classPendingEnrollmentRequest === undefined) {
            throw new runtime.RequiredError('classPendingEnrollmentRequest','Required parameter requestParameters.classPendingEnrollmentRequest was null or undefined when calling classControllerGetPendingEnrollment.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/class/pending-enrollment`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClassPendingEnrollmentRequestToJSON(requestParameters.classPendingEnrollmentRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClassPendingEnrollmentResponseFromJSON(jsonValue));
    }

    /**
     */
    async classControllerGetPendingEnrollment(requestParameters: ClassControllerGetPendingEnrollmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClassPendingEnrollmentResponse> {
        const response = await this.classControllerGetPendingEnrollmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async classControllerListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClassListResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/class/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClassListResponseFromJSON(jsonValue));
    }

    /**
     */
    async classControllerList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClassListResponse> {
        const response = await this.classControllerListRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async classControllerRosterRaw(requestParameters: ClassControllerRosterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClassRosterResponse>> {
        if (requestParameters.classRosterRequest === null || requestParameters.classRosterRequest === undefined) {
            throw new runtime.RequiredError('classRosterRequest','Required parameter requestParameters.classRosterRequest was null or undefined when calling classControllerRoster.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/class/roster`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClassRosterRequestToJSON(requestParameters.classRosterRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClassRosterResponseFromJSON(jsonValue));
    }

    /**
     */
    async classControllerRoster(requestParameters: ClassControllerRosterRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClassRosterResponse> {
        const response = await this.classControllerRosterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async classControllerUpdateMetadataRaw(requestParameters: ClassControllerUpdateMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClassUpdateMetadataResponse>> {
        if (requestParameters.classUpdateMetadataRequest === null || requestParameters.classUpdateMetadataRequest === undefined) {
            throw new runtime.RequiredError('classUpdateMetadataRequest','Required parameter requestParameters.classUpdateMetadataRequest was null or undefined when calling classControllerUpdateMetadata.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/class/update-metadata`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ClassUpdateMetadataRequestToJSON(requestParameters.classUpdateMetadataRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClassUpdateMetadataResponseFromJSON(jsonValue));
    }

    /**
     */
    async classControllerUpdateMetadata(requestParameters: ClassControllerUpdateMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClassUpdateMetadataResponse> {
        const response = await this.classControllerUpdateMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async consentControllerGetConsentStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/consent`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async consentControllerGetConsentStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.consentControllerGetConsentStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async consentControllerUpdateConsentStatusRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<boolean>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/consent`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<boolean>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     */
    async consentControllerUpdateConsentStatus(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<boolean> {
        const response = await this.consentControllerUpdateConsentStatusRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async documentControllerAddChunkFieldRaw(requestParameters: DocumentControllerAddChunkFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChunkEditResponse>> {
        if (requestParameters.chunkEditRequest === null || requestParameters.chunkEditRequest === undefined) {
            throw new runtime.RequiredError('chunkEditRequest','Required parameter requestParameters.chunkEditRequest was null or undefined when calling documentControllerAddChunkField.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/document/chunk/add`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChunkEditRequestToJSON(requestParameters.chunkEditRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChunkEditResponseFromJSON(jsonValue));
    }

    /**
     */
    async documentControllerAddChunkField(requestParameters: DocumentControllerAddChunkFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChunkEditResponse> {
        const response = await this.documentControllerAddChunkFieldRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentControllerChunkRaw(requestParameters: DocumentControllerChunkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChunkQueueResponse>> {
        if (requestParameters.chunkRequest === null || requestParameters.chunkRequest === undefined) {
            throw new runtime.RequiredError('chunkRequest','Required parameter requestParameters.chunkRequest was null or undefined when calling documentControllerChunk.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/document/chunk`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChunkRequestToJSON(requestParameters.chunkRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChunkQueueResponseFromJSON(jsonValue));
    }

    /**
     */
    async documentControllerChunk(requestParameters: DocumentControllerChunkRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChunkQueueResponse> {
        const response = await this.documentControllerChunkRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentControllerChunkStatusRaw(requestParameters: DocumentControllerChunkStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChunkStatusResponse>> {
        if (requestParameters.chunkQueueRequest === null || requestParameters.chunkQueueRequest === undefined) {
            throw new runtime.RequiredError('chunkQueueRequest','Required parameter requestParameters.chunkQueueRequest was null or undefined when calling documentControllerChunkStatus.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/document/chunk/status`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChunkQueueRequestToJSON(requestParameters.chunkQueueRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChunkStatusResponseFromJSON(jsonValue));
    }

    /**
     */
    async documentControllerChunkStatus(requestParameters: DocumentControllerChunkStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChunkStatusResponse> {
        const response = await this.documentControllerChunkStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentControllerDeleteChunkViaPostRaw(requestParameters: DocumentControllerDeleteChunkViaPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChunkEditResponse>> {
        if (requestParameters.chunkDeleteRequest === null || requestParameters.chunkDeleteRequest === undefined) {
            throw new runtime.RequiredError('chunkDeleteRequest','Required parameter requestParameters.chunkDeleteRequest was null or undefined when calling documentControllerDeleteChunkViaPost.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/document/chunk/delete`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChunkDeleteRequestToJSON(requestParameters.chunkDeleteRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChunkEditResponseFromJSON(jsonValue));
    }

    /**
     */
    async documentControllerDeleteChunkViaPost(requestParameters: DocumentControllerDeleteChunkViaPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChunkEditResponse> {
        const response = await this.documentControllerDeleteChunkViaPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentControllerDescribeRaw(requestParameters: DocumentControllerDescribeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DescribeResponse>> {
        if (requestParameters.chunkRequest === null || requestParameters.chunkRequest === undefined) {
            throw new runtime.RequiredError('chunkRequest','Required parameter requestParameters.chunkRequest was null or undefined when calling documentControllerDescribe.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/document/describe`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChunkRequestToJSON(requestParameters.chunkRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DescribeResponseFromJSON(jsonValue));
    }

    /**
     */
    async documentControllerDescribe(requestParameters: DocumentControllerDescribeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DescribeResponse> {
        const response = await this.documentControllerDescribeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentControllerEditChunkFieldRaw(requestParameters: DocumentControllerEditChunkFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ChunkEditResponse>> {
        if (requestParameters.chunkEditRequest === null || requestParameters.chunkEditRequest === undefined) {
            throw new runtime.RequiredError('chunkEditRequest','Required parameter requestParameters.chunkEditRequest was null or undefined when calling documentControllerEditChunkField.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/document/chunk/edit`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChunkEditRequestToJSON(requestParameters.chunkEditRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ChunkEditResponseFromJSON(jsonValue));
    }

    /**
     */
    async documentControllerEditChunkField(requestParameters: DocumentControllerEditChunkFieldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ChunkEditResponse> {
        const response = await this.documentControllerEditChunkFieldRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentControllerEmbedRaw(requestParameters: DocumentControllerEmbedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DescribeResponse>> {
        if (requestParameters.chunkRequest === null || requestParameters.chunkRequest === undefined) {
            throw new runtime.RequiredError('chunkRequest','Required parameter requestParameters.chunkRequest was null or undefined when calling documentControllerEmbed.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/document/embed`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChunkRequestToJSON(requestParameters.chunkRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DescribeResponseFromJSON(jsonValue));
    }

    /**
     */
    async documentControllerEmbed(requestParameters: DocumentControllerEmbedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DescribeResponse> {
        const response = await this.documentControllerEmbedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentControllerGetListByMaterialIdRaw(requestParameters: DocumentControllerGetListByMaterialIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentListResponse>> {
        if (requestParameters.materialID === null || requestParameters.materialID === undefined) {
            throw new runtime.RequiredError('materialID','Required parameter requestParameters.materialID was null or undefined when calling documentControllerGetListByMaterialId.');
        }

        const queryParameters: any = {};

        if (requestParameters.materialID !== undefined) {
            queryParameters['materialID'] = requestParameters.materialID;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/document/material/id`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentListResponseFromJSON(jsonValue));
    }

    /**
     */
    async documentControllerGetListByMaterialId(requestParameters: DocumentControllerGetListByMaterialIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentListResponse> {
        const response = await this.documentControllerGetListByMaterialIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentControllerQueryRaw(requestParameters: DocumentControllerQueryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<QueryResponse>> {
        if (requestParameters.queryRequest === null || requestParameters.queryRequest === undefined) {
            throw new runtime.RequiredError('queryRequest','Required parameter requestParameters.queryRequest was null or undefined when calling documentControllerQuery.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/document/query`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: QueryRequestToJSON(requestParameters.queryRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => QueryResponseFromJSON(jsonValue));
    }

    /**
     */
    async documentControllerQuery(requestParameters: DocumentControllerQueryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<QueryResponse> {
        const response = await this.documentControllerQueryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentControllerRemoveEmbedRaw(requestParameters: DocumentControllerRemoveEmbedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DescribeResponse>> {
        if (requestParameters.chunkRequest === null || requestParameters.chunkRequest === undefined) {
            throw new runtime.RequiredError('chunkRequest','Required parameter requestParameters.chunkRequest was null or undefined when calling documentControllerRemoveEmbed.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/document/embed/remove`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChunkRequestToJSON(requestParameters.chunkRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DescribeResponseFromJSON(jsonValue));
    }

    /**
     */
    async documentControllerRemoveEmbed(requestParameters: DocumentControllerRemoveEmbedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DescribeResponse> {
        const response = await this.documentControllerRemoveEmbedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentControllerRetrieveDocumentRaw(requestParameters: DocumentControllerRetrieveDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDocumentResponse>> {
        if (requestParameters.chunkRequest === null || requestParameters.chunkRequest === undefined) {
            throw new runtime.RequiredError('chunkRequest','Required parameter requestParameters.chunkRequest was null or undefined when calling documentControllerRetrieveDocument.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/document`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ChunkRequestToJSON(requestParameters.chunkRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDocumentResponseFromJSON(jsonValue));
    }

    /**
     */
    async documentControllerRetrieveDocument(requestParameters: DocumentControllerRetrieveDocumentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDocumentResponse> {
        const response = await this.documentControllerRetrieveDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async documentControllerUploadRaw(requestParameters: DocumentControllerUploadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentUploadResponse>> {
        if (requestParameters.file === null || requestParameters.file === undefined) {
            throw new runtime.RequiredError('file','Required parameter requestParameters.file was null or undefined when calling documentControllerUpload.');
        }

        if (requestParameters.classMaterialId === null || requestParameters.classMaterialId === undefined) {
            throw new runtime.RequiredError('classMaterialId','Required parameter requestParameters.classMaterialId was null or undefined when calling documentControllerUpload.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.file !== undefined) {
            formParams.append('file', requestParameters.file as any);
        }

        if (requestParameters.classMaterialId !== undefined) {
            formParams.append('classMaterialId', requestParameters.classMaterialId as any);
        }

        const response = await this.request({
            path: `/document/upload`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentUploadResponseFromJSON(jsonValue));
    }

    /**
     */
    async documentControllerUpload(requestParameters: DocumentControllerUploadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentUploadResponse> {
        const response = await this.documentControllerUploadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async embeddingControllerCreateEmbeddingRaw(requestParameters: EmbeddingControllerCreateEmbeddingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmbeddingResponseDto>> {
        if (requestParameters.createEmbeddingDto === null || requestParameters.createEmbeddingDto === undefined) {
            throw new runtime.RequiredError('createEmbeddingDto','Required parameter requestParameters.createEmbeddingDto was null or undefined when calling embeddingControllerCreateEmbedding.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/embedding/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateEmbeddingDtoToJSON(requestParameters.createEmbeddingDto),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmbeddingResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async embeddingControllerCreateEmbedding(requestParameters: EmbeddingControllerCreateEmbeddingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmbeddingResponseDto> {
        const response = await this.embeddingControllerCreateEmbeddingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async featureFlagsControllerAddClassFeatureRaw(requestParameters: FeatureFlagsControllerAddClassFeatureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.addFeatureRequest === null || requestParameters.addFeatureRequest === undefined) {
            throw new runtime.RequiredError('addFeatureRequest','Required parameter requestParameters.addFeatureRequest was null or undefined when calling featureFlagsControllerAddClassFeature.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/feature-flags/class/add`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddFeatureRequestToJSON(requestParameters.addFeatureRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async featureFlagsControllerAddClassFeature(requestParameters: FeatureFlagsControllerAddClassFeatureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.featureFlagsControllerAddClassFeatureRaw(requestParameters, initOverrides);
    }

    /**
     */
    async featureFlagsControllerAddUserFeatureRaw(requestParameters: FeatureFlagsControllerAddUserFeatureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.addFeatureRequest === null || requestParameters.addFeatureRequest === undefined) {
            throw new runtime.RequiredError('addFeatureRequest','Required parameter requestParameters.addFeatureRequest was null or undefined when calling featureFlagsControllerAddUserFeature.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/feature-flags/user/add`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddFeatureRequestToJSON(requestParameters.addFeatureRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async featureFlagsControllerAddUserFeature(requestParameters: FeatureFlagsControllerAddUserFeatureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.featureFlagsControllerAddUserFeatureRaw(requestParameters, initOverrides);
    }

    /**
     */
    async featureFlagsControllerEditClassFeatureRaw(requestParameters: FeatureFlagsControllerEditClassFeatureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.editFeatureRequest === null || requestParameters.editFeatureRequest === undefined) {
            throw new runtime.RequiredError('editFeatureRequest','Required parameter requestParameters.editFeatureRequest was null or undefined when calling featureFlagsControllerEditClassFeature.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/feature-flags/class/edit`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: EditFeatureRequestToJSON(requestParameters.editFeatureRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async featureFlagsControllerEditClassFeature(requestParameters: FeatureFlagsControllerEditClassFeatureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.featureFlagsControllerEditClassFeatureRaw(requestParameters, initOverrides);
    }

    /**
     */
    async featureFlagsControllerEditUserFeatureRaw(requestParameters: FeatureFlagsControllerEditUserFeatureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.editFeatureRequest === null || requestParameters.editFeatureRequest === undefined) {
            throw new runtime.RequiredError('editFeatureRequest','Required parameter requestParameters.editFeatureRequest was null or undefined when calling featureFlagsControllerEditUserFeature.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/feature-flags/user/edit`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: EditFeatureRequestToJSON(requestParameters.editFeatureRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async featureFlagsControllerEditUserFeature(requestParameters: FeatureFlagsControllerEditUserFeatureRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.featureFlagsControllerEditUserFeatureRaw(requestParameters, initOverrides);
    }

    /**
     */
    async featureFlagsControllerListAllFeaturesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FeatureResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/feature-flags/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FeatureResponseFromJSON));
    }

    /**
     */
    async featureFlagsControllerListAllFeatures(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FeatureResponse>> {
        const response = await this.featureFlagsControllerListAllFeaturesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async featureFlagsControllerListClassFeaturesRaw(requestParameters: FeatureFlagsControllerListClassFeaturesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FeatureResponse>>> {
        if (requestParameters.classId === null || requestParameters.classId === undefined) {
            throw new runtime.RequiredError('classId','Required parameter requestParameters.classId was null or undefined when calling featureFlagsControllerListClassFeatures.');
        }

        const queryParameters: any = {};

        if (requestParameters.classId !== undefined) {
            queryParameters['classId'] = requestParameters.classId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/feature-flags/class/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FeatureResponseFromJSON));
    }

    /**
     */
    async featureFlagsControllerListClassFeatures(requestParameters: FeatureFlagsControllerListClassFeaturesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FeatureResponse>> {
        const response = await this.featureFlagsControllerListClassFeaturesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async featureFlagsControllerListMyFeaturesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FeatureResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/feature-flags/me/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FeatureResponseFromJSON));
    }

    /**
     */
    async featureFlagsControllerListMyFeatures(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FeatureResponse>> {
        const response = await this.featureFlagsControllerListMyFeaturesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async featureFlagsControllerListUserFeaturesRaw(requestParameters: FeatureFlagsControllerListUserFeaturesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FeatureResponse>>> {
        if (requestParameters.userId === null || requestParameters.userId === undefined) {
            throw new runtime.RequiredError('userId','Required parameter requestParameters.userId was null or undefined when calling featureFlagsControllerListUserFeatures.');
        }

        const queryParameters: any = {};

        if (requestParameters.userId !== undefined) {
            queryParameters['userId'] = requestParameters.userId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/feature-flags/user/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FeatureResponseFromJSON));
    }

    /**
     */
    async featureFlagsControllerListUserFeatures(requestParameters: FeatureFlagsControllerListUserFeaturesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FeatureResponse>> {
        const response = await this.featureFlagsControllerListUserFeaturesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async healthControllerCheckRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HealthControllerCheck200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/health`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HealthControllerCheck200ResponseFromJSON(jsonValue));
    }

    /**
     */
    async healthControllerCheck(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HealthControllerCheck200Response> {
        const response = await this.healthControllerCheckRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async interactionControllerAddInteractionRaw(requestParameters: InteractionControllerAddInteractionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddInteractionResponse>> {
        if (requestParameters.addInteractionRequest === null || requestParameters.addInteractionRequest === undefined) {
            throw new runtime.RequiredError('addInteractionRequest','Required parameter requestParameters.addInteractionRequest was null or undefined when calling interactionControllerAddInteraction.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/interaction/add`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddInteractionRequestToJSON(requestParameters.addInteractionRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddInteractionResponseFromJSON(jsonValue));
    }

    /**
     */
    async interactionControllerAddInteraction(requestParameters: InteractionControllerAddInteractionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddInteractionResponse> {
        const response = await this.interactionControllerAddInteractionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async interactionControllerAddInteractionActionRaw(requestParameters: InteractionControllerAddInteractionActionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddInteractionResponse>> {
        if (requestParameters.addInteractionActionRequest === null || requestParameters.addInteractionActionRequest === undefined) {
            throw new runtime.RequiredError('addInteractionActionRequest','Required parameter requestParameters.addInteractionActionRequest was null or undefined when calling interactionControllerAddInteractionAction.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/interaction/action/add`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddInteractionActionRequestToJSON(requestParameters.addInteractionActionRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddInteractionResponseFromJSON(jsonValue));
    }

    /**
     */
    async interactionControllerAddInteractionAction(requestParameters: InteractionControllerAddInteractionActionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddInteractionResponse> {
        const response = await this.interactionControllerAddInteractionActionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async materialControllerAddRaw(requestParameters: MaterialControllerAddRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MaterialAddResponse>> {
        if (requestParameters.materialAddRequest === null || requestParameters.materialAddRequest === undefined) {
            throw new runtime.RequiredError('materialAddRequest','Required parameter requestParameters.materialAddRequest was null or undefined when calling materialControllerAdd.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/class/material/add`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MaterialAddRequestToJSON(requestParameters.materialAddRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MaterialAddResponseFromJSON(jsonValue));
    }

    /**
     */
    async materialControllerAdd(requestParameters: MaterialControllerAddRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MaterialAddResponse> {
        const response = await this.materialControllerAddRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async materialControllerDeleteRaw(requestParameters: MaterialControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.materialDeleteRequest === null || requestParameters.materialDeleteRequest === undefined) {
            throw new runtime.RequiredError('materialDeleteRequest','Required parameter requestParameters.materialDeleteRequest was null or undefined when calling materialControllerDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/class/material/delete`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: MaterialDeleteRequestToJSON(requestParameters.materialDeleteRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async materialControllerDelete(requestParameters: MaterialControllerDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.materialControllerDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async materialControllerEditRaw(requestParameters: MaterialControllerEditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MaterialEditResponse>> {
        if (requestParameters.materialEditRequest === null || requestParameters.materialEditRequest === undefined) {
            throw new runtime.RequiredError('materialEditRequest','Required parameter requestParameters.materialEditRequest was null or undefined when calling materialControllerEdit.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/class/material/edit`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: MaterialEditRequestToJSON(requestParameters.materialEditRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MaterialEditResponseFromJSON(jsonValue));
    }

    /**
     */
    async materialControllerEdit(requestParameters: MaterialControllerEditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MaterialEditResponse> {
        const response = await this.materialControllerEditRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async materialControllerGetListByMaterialIdRaw(requestParameters: MaterialControllerGetListByMaterialIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentListResponse>> {
        if (requestParameters.materialID === null || requestParameters.materialID === undefined) {
            throw new runtime.RequiredError('materialID','Required parameter requestParameters.materialID was null or undefined when calling materialControllerGetListByMaterialId.');
        }

        const queryParameters: any = {};

        if (requestParameters.materialID !== undefined) {
            queryParameters['materialID'] = requestParameters.materialID;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/class/material/list/id`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentListResponseFromJSON(jsonValue));
    }

    /**
     */
    async materialControllerGetListByMaterialId(requestParameters: MaterialControllerGetListByMaterialIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentListResponse> {
        const response = await this.materialControllerGetListByMaterialIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async materialControllerListRaw(requestParameters: MaterialControllerListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MaterialListResponse>> {
        if (requestParameters.materialListRequest === null || requestParameters.materialListRequest === undefined) {
            throw new runtime.RequiredError('materialListRequest','Required parameter requestParameters.materialListRequest was null or undefined when calling materialControllerList.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/class/material/list`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MaterialListRequestToJSON(requestParameters.materialListRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MaterialListResponseFromJSON(jsonValue));
    }

    /**
     */
    async materialControllerList(requestParameters: MaterialControllerListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MaterialListResponse> {
        const response = await this.materialControllerListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async studentControllerBeaconRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/student/beacon`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async studentControllerBeacon(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.studentControllerBeaconRaw(initOverrides);
    }

    /**
     */
    async studentControllerChatRaw(requestParameters: StudentControllerChatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StudentChatResponse>> {
        if (requestParameters.studentChatRequest === null || requestParameters.studentChatRequest === undefined) {
            throw new runtime.RequiredError('studentChatRequest','Required parameter requestParameters.studentChatRequest was null or undefined when calling studentControllerChat.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/student/chat`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StudentChatRequestToJSON(requestParameters.studentChatRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StudentChatResponseFromJSON(jsonValue));
    }

    /**
     */
    async studentControllerChat(requestParameters: StudentControllerChatRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StudentChatResponse> {
        const response = await this.studentControllerChatRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async studentControllerGetEnrolledClassesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StudentEnrollmentsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/student/enrollments`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StudentEnrollmentsResponseFromJSON(jsonValue));
    }

    /**
     */
    async studentControllerGetEnrolledClasses(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StudentEnrollmentsResponse> {
        const response = await this.studentControllerGetEnrolledClassesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async studentControllerSummaryRaw(requestParameters: StudentControllerSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StudentSummaryResponse>> {
        if (requestParameters.studentSummaryRequest === null || requestParameters.studentSummaryRequest === undefined) {
            throw new runtime.RequiredError('studentSummaryRequest','Required parameter requestParameters.studentSummaryRequest was null or undefined when calling studentControllerSummary.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/student/summary`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StudentSummaryRequestToJSON(requestParameters.studentSummaryRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StudentSummaryResponseFromJSON(jsonValue));
    }

    /**
     */
    async studentControllerSummary(requestParameters: StudentControllerSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StudentSummaryResponse> {
        const response = await this.studentControllerSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async whitelistControllerAddUserToWhitelistRaw(requestParameters: WhitelistControllerAddUserToWhitelistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.addWhitelistRequest === null || requestParameters.addWhitelistRequest === undefined) {
            throw new runtime.RequiredError('addWhitelistRequest','Required parameter requestParameters.addWhitelistRequest was null or undefined when calling whitelistControllerAddUserToWhitelist.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/whitelist/create`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddWhitelistRequestToJSON(requestParameters.addWhitelistRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async whitelistControllerAddUserToWhitelist(requestParameters: WhitelistControllerAddUserToWhitelistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.whitelistControllerAddUserToWhitelistRaw(requestParameters, initOverrides);
    }

    /**
     */
    async whitelistControllerListWhitelistUsersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListWhitelistResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/whitelist/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListWhitelistResponseFromJSON(jsonValue));
    }

    /**
     */
    async whitelistControllerListWhitelistUsers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListWhitelistResponse> {
        const response = await this.whitelistControllerListWhitelistUsersRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async whitelistControllerUpdateUserWhitelistRaw(requestParameters: WhitelistControllerUpdateUserWhitelistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.updateWhitelistRequest === null || requestParameters.updateWhitelistRequest === undefined) {
            throw new runtime.RequiredError('updateWhitelistRequest','Required parameter requestParameters.updateWhitelistRequest was null or undefined when calling whitelistControllerUpdateUserWhitelist.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/whitelist/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateWhitelistRequestToJSON(requestParameters.updateWhitelistRequest),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async whitelistControllerUpdateUserWhitelist(requestParameters: WhitelistControllerUpdateUserWhitelistRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.whitelistControllerUpdateUserWhitelistRaw(requestParameters, initOverrides);
    }

}
